import React, { useEffect, useState } from "react";
import axios from "axios";
import { config, IMAGE_URL, projectname, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Input,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import the CSS
import styles from "./styles.css";
import { format } from 'date-fns';
import { purple } from "@material-ui/core/colors";
import LOADER from "../../assets/img/barakahhijama.gif";
import AppointmentMap from "./AppointmentMap";

function AppointmentList() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();
  const [tags, setTags] = useState([]);
  const [formData, setFormData] = useState([]);
  const [loading, setloading] = useState(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedDate, setSelectedDate] = useState(null);
  const currentDate = new Date();

  const con = {
    headers: {
      ContentType: 'application/json',
      Authorization: "Bearer " + localStorage.getItem("njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras"),
    },
  };
  useEffect(() => {
    getTimeSlots();
    axios.get(URL_API + "efjsondfasdfataforbarakahijamajsondataforbarakahijamaa").then((response) => {
      if (response?.data?.status === 200) {
        setFormData(response?.data);
      }
    });
    const interval = setInterval(() => {
      getTimeSlots();
    }, 90000);
    return () => clearInterval(interval);
  }, []);

  const getTimeSlots = () => {
    axios.get(URL_API + "auth/admin/appointment", con).then((response) => {
      if (response?.data?.status === 200) {
        setTags(response?.data?.appointments);
        setloading(false)
      }
    });
  };

  const destroyTag = (id) => {
    axios
      .post(URL_API + `auth/admin/category-delete/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/categories");
          toast.success("Category Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getTimeSlots();
        }
      });
  };



  const onAddTimeSlotSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
    const formattedDate = selectedDate ? format(selectedDate, 'yyyy-MM-dd') : null;

    formData.append("date", formattedDate);

    axios
      .post(URL_API + "auth/admin/timeslot", formData, con)
      .then((response) => {
        console.log('hehehehe', response)
        if (response.status == 200) {
          // history.push("/admin/tags");/
          getTimeSlots();
          toast.success("Time Slots Added Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setShow(false)
          // setName("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const uniqueItems = [...new Set(tags?.map(item => item?.updated_at))].map(updated_at => {
    return tags?.find(item => item?.updated_at === updated_at);
  });


  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null); // State to track which item is being edited


  // Function to update an item in the list
  const updateItemInList = (formData) => {
    axios
      .post(URL_API + `auth/admin/updateAppointment`, formData, con)
      .then((response) => {
        console.log('hehehehe', response)
        if (response.status == 200) {
          setEditingId(null)
          getTimeSlots()
          // history.push("/admin/tags");/
          // getTimeSlots();
          toast.success("Appointment Updated Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setShow(false)
          // setName("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };



  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" style={{ fontWeight: "100" }}>
                  {projectname} | <i class="fa fa-home" aria-hidden="true"></i> |
                  Appointments
                </CardTitle>
              </CardHeader>
              {/* <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <a >
                  <strong onClick={() => setShow(true)}>Add Appointment + </strong>
                </a>
              </div> */}
              <CardBody>
                <Table responsive>


                  {loading == true ? (
                    <>
                      <div className="loader">
                        <img src={LOADER} />
                      </div>
                    </>

                  )

                    :
                    <>
                      <tbody>


                        <tr className="text-center-line-heading">
                          <th>#</th>
                          {/* <th>Time</th> */}
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Gender</th>
                          <th>Category</th>
                          <th>Confirm</th>
                          <th>Created At</th>
                          <th>Action</th>
                        </tr>
                        {tags?.map((ts, index) => {
                          return <>
                            <AppointmentMap
                              ts={ts}
                              tsIndex={index}
                              onUpdate={updateItemInList}
                              isEditing={editingId}
                              setIsEditing={setEditingId}
                              formData={formData} />

                          </>
                        })}
                      </tbody>
                    </>

                  }

                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>



        <Modal
          show={show}
          onHide={handleClose}
          style={{ marginTop: "100px", marginLeft: "-11px" }}
        >
          <Modal.Header>
            <Modal.Title className=" ml-auto mr-auto pr-1">
              Add Time Slot
            </Modal.Title>
          </Modal.Header>
          {/* <form> */}
          <form onSubmit={(e) => onAddTimeSlotSubmit(e)}>
            <div className={`container-fluid`}>
              <div className={styles.HeroiImgBlogForm}></div>
              <div className="container">
                <div className={`form ${styles.blogPostForm}`}>
                  <div className="form-group">
                    <div htmlFor="form-group" className={styles.labelPostForm} style={{ textAlign: 'center' }}>
                      Select Date &nbsp;&nbsp;

                      <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        dateFormat="yyyy-MM-dd" // Display format for the user
                        minDate={currentDate} // Set the minimum selectable date to today
                        popperClassName="example-datepicker-class"
                        showIcon={true}
                      />
                    </div>

                  </div>


                  <Input
                    type="submit"
                    name="submit"
                    className={`btn btn-danger ${styles.blogPostFormBtn}`}
                    value="Submit"
                  />
                </div>
                <br />
              </div>
            </div>
          </form>
        </Modal>
      </div >
    </>
  );
}

export default AppointmentList;
